module.exports = __webpack_public_path__ + "img/pic1.955016d7.png";